<template>
  <div>
    <div class="phone-line" :class="{bottomLine:areaCode!=86}">
      <span v-show="numType=='phone'" class="country code-box" @click="pop2=true" :class="{bottomLine:areaCode==86}">
        <em>+{{areaCode}}</em>
        <i class="iconfont icon-xiala-copy"></i>
      </span>
      <div class="phone-in" v-show="numType=='phone'">
        <div class="separate-box" @click="inputClick('phoneDom')" v-show="areaCode==86">
          <i v-for="i in 11" :key="i" :class="{bottomLine:areaCode==86}">{{pwdArray[i-1]}}</i>
        </div>
        <input
          v-model="userParam.mobileInput"
          :class="{outStyle:phoneInput}"
          @focus="inputFocus('phoneInput')"
          @input="separateNum('mobileInput','phoneDom')"
          ref="phoneDom"
          type="number"
          placeholder="请输入手机号">
      </div>
    </div>

    <div class="validate-line" v-show="numType=='code'">
      <div class="separate-box" @click="inputClick('codeDom')">
        <i v-for="i in codeNum" :key="i" :class="{little:codeNum==6}" class="bottomLine">{{codeArray[i-1]}}</i>
      </div>
      <input
        type="text"
        v-model="userParam.code"
        :class="{outStyle:codeInput}"
        @focus="inputFocus('codeInput')"
        @input="separateNum('code','codeDom')"
        ref="codeDom"
        placeholder="请输入验证码">
      <div class="right-btn">
        <span class="get-code" v-show="codestate==0" @click="setCode1()">获取验证码</span>
        <span v-show="codestate==1">已发送{{secondNum}}s</span>
      </div>
    </div>
    <div class="voice-box" v-show="voiceShow&&tab==1">
      <span v-show="voiceState" @click="voiceVerification(this)">收不到短信？试试<em>语音验证</em></span>
      <span v-show="!voiceState">请注意接听语音验证电话（{{secondNum}}s）</span>
    </div>

    <mt-popup v-model="pop2" position="bottom" class="addresspop pickerPop">
      <areaBlock @codeChange="getArea" @closePop="pop2=false" v-show="pop2==true"></areaBlock>
    </mt-popup>
  </div>
</template>

<script>
  import {ajax,setMessage,getMessage} from '../../assets/js/common'
  import areaBlock from "./areaBlock.vue"
  export default{
    props:["numType","codeType","clear"],//numType:phone,此时分隔框为手机11位分隔；numType:code,此时分隔框为验证码分隔
    data(){
      return{
        tab:1,
        userParam:{
          "pwdNum":"",
          "mobileInput":"",
          "email":""
        },
        userType:"",
        boxShow:"",
        pwdSet:true,//true表示已设置密码，false未设置
        pwdshow:false,
        voiceShow:false,
        voiceState:true,
        secondNum:60,
        codestate:0,
        pop2:false,
        popupVisible2:false,
        popupVisible3:false,
        areaCode:86,
        phoneInput:false,
        codeInput:false,
        pwdArray:[],
        codeArray:[],
        nextStep:true,//控制下一步按钮的显示
        submitShow:false,//控制登录、注册按钮的显示
        loginRegBtn:true,
        backType:false,//true表示由设置密码等页面跳回，需保留信息
      }
    },
    components:{
      areaBlock
    },
    watch:{
      areaCode(val){
        this.inputFocus('phoneInput');
        this.codeClear();
        // if(!this.backType){
        //   this.goOrigin();
        // }
        // else{
        //   this.backType=false;
        // }
      },
      codeType(val){
        this.tab=val;
      },
      clear(val){
        if(val==true){
          this.codeClear();
        }
      }
    },
    mounted(){
      this.$nextTick(()=>{
        // this.showCodeBox();
        let setParam=sessionStorage.getItem('setParam');
        if(setParam){
          setParam=JSON.parse(setParam);
          this.backType=true;
          this.tab=setParam.type;
          if(this.tab==1){
            this.areaCode=setParam.areaCode;
            this.userParam.mobileInput=setParam.mobile;
          }
          else{
            this.userParam.email=setParam.email;
          }
          // this.showCodeBox();
          this.inputFocus('phoneInput');
          this.separateNum("mobileInput","phoneDom");
        }
      })
    },
    computed:{
      codeNum(){
        let val;
        if(this.tab==1){
          val=4;
        }
        else{
          val=6;
        }
        return val;
      }
    },
    methods:{
      codeClear(){
        this.userParam.code="";
        this.userParam.mobileInput="";
        this.pwdArray=[];
        this.codeArray=[];
      },
      getArea(val){
        this.pop2=false;
        this.areaCode=val;
      },
      loginSwitch(){
        if(this.boxShow=='code'){
          this.boxShow='pwd';
        }
        else if(this.boxShow=='pwd'){
          this.boxShow='code';
        }
      },
      /*发送验证码*/
      setCode1(){
        var codetype="validate";
        var vparam;
        vparam="FzmRandom";
        if(this.tab==1){
          if(!this.voiceState){
            return false;
          }
          if(this.userParam.mobileInput==""){
            this.Toast("请先输入手机号");
            return false;
          }
          this.voiceShow=false;
          this.popupVisible2=true;

          this.codestate=1;
          return;

          setCode(this,codetype,vparam,this.userParam.mobileInput,(data)=>{
            this.popupVisible2=false;
          });
        }
        else if(this.tab==2){
          let name=$("#login-name").val();
          if(name==""){
            this.Toast("请先输入邮箱");
            return false;
          }
          this.popupVisible2=true;
          vparam="FzmDateTime|FzmRandom";
          setEmail(this,codetype,vparam,name,(data)=>{
            this.popupVisible2=false;
          });
        }
      },
      /*语音验证*/
      voiceVerification(){
        // if(this.reUser==""){
        //   this.Toast("请先输入手机号");
        //   return false;
        // }
        let param={
          area:this.areaCode,
          // mobile:this.reUser
        };
        speechVerification(this,param);
      },
      inputClick(val){
        this.$refs[val].focus();
      },
      /*拆分input输入值*/
      separateNum(val,ref){
        // let array=this.userParam[val].toString().split('');
        // if(val=='mobileInput'){
        //   this.pwdArray=array;
        // }
        // else{
        //   this.codeArray=array;
        // }
        // if(array.length>10){
        //   this.$refs[ref].blur();
        // }
        // if(array.length==11){
        //   this.showCodeBox();
        // }
        // if(array.length==0){
        //   this.showCodeBox();
        // }
        let array=this.userParam[val].toString().split('');

        if(val=='mobileInput'){
          this.pwdArray=array;
          if(this.areaCode==86){
            if(array.length>10){
              this.$nextTick(()=>{
                this.$refs[ref].blur();
              })
              // this.$refs[ref].blur();
            }
            if(array.length==11){
              this.$emit("phoneOver",this.userParam.mobileInput,'phone');
              // this.showCodeBox();
            }
          }
        }
        else{
          this.codeArray=array;
          if(array.length>3){
            this.$nextTick(()=>{
              this.$refs[ref].blur();
            })
          }
        }
      },
      /*显示验证码输入框*/
      showCodeBox(){
        this.nextStep=false;
        this.submitShow=true;
        this.userType='login';
        if(this.userType=='reg'){
          this.boxShow='code';
        }
        else{
          if(this.pwdSet){
            this.boxShow='pwd';
          }
          else{
            this.boxShow='code';
          }
        }
      },
      /*手机输入框获取焦点*/
      inputFocus(val){
        if(val=='phoneInput'){
          if(this.areaCode==86){
            this.phoneInput=true;
          }
          else{
            this.phoneInput=false;
          }
        }
        else{
          this[val]=true;
          // if(this.tab==1){
          //   this[val]=true;
          // }
          // else{
          //   this[val]=false;
          // }
        }
      },
      selectSure(){
        this.pop2=false;
        this.areaCode=this.countryVal.code;
      },
    },
  }
</script>



// WEBPACK FOOTER //
// src/views/login/separate-num.vue